import './App.css'; 
import React from 'react';
import InitialPage from "./views/InitialPage/InitialPage";
import { useEffect } from 'react';

function App() {
  useEffect(() => {
    const currentURL = window.location.href;
    const titleElement = document.getElementById('page-title');
    const faviconElement = document.getElementById('favicon');
    window.urlEndpoint = "https://api.quieromac.com/";

    if (titleElement && faviconElement) {
      if (currentURL.includes("quieromac")) {
        document.documentElement.style.setProperty("--primary-color", "#ff9400");
        titleElement.innerText = "QuieroMac - Retomas";
        faviconElement.href = "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTrEAj1ZzHep7JoRKHFUMmWFd4ocG04GCYpmw&s";
        window.redirectUrl = 'https://quieromac.com/';
        window.tagend = '_quieromac';
      } else if (currentURL.includes("celucambio")) {
        document.documentElement.style.setProperty("--primary-color", "#01d95a");
        titleElement.innerText = "Celucambio - Retomas";
        faviconElement.href = "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRGwXw9mmAuwbjR_-x8pG7pqzMgGP47iLYhPg&s";
        window.redirectUrl = 'https://celucambio.com/';
        window.tagend = '';
      } else {
        // Default values
        titleElement.innerText = "Default Title";
        faviconElement.href = "https://path-to-default-icon.png";
      }
    } else {
      console.error("Element with id 'page-title' or 'favicon' not found.");
    }
  }, []);
  return (
    <div className="App">
      <InitialPage/>
    </div>
  );
}

export default App;
